var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#007AFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.167 0c.46 0 .833.373.833.833V2.5h4.167c.46 0 .833.373.833.833v15c0 .46-.373.834-.833.834H.833c-.46 0-.833-.373-.833-.834v-15c0-.46.373-.833.833-.833H5V.833C5 .373 5.373 0 5.833 0c.46 0 .834.373.834.833V2.5h6.666V.833c0-.46.373-.833.834-.833zm4.166 5.833H1.667V17.5h16.666V5.833zm-4.166 2.155l1.178 1.179-5.59 5.589c-.155.156-.367.244-.588.244-.221 0-.433-.088-.59-.244l-3.089-3.09 1.179-1.178 2.5 2.5 5-5z",
    transform: "translate(-892 -492) translate(645 459) translate(155 21) translate(92 12)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon_schedule.f9601f3aa549c7b2712390a6fbe5694a.svg";
export { ForwardRef as ReactComponent };